import { render, staticRenderFns } from "./HighFrequency.vue?vue&type=template&id=1366a4e9&scoped=true"
import script from "./HighFrequency.vue?vue&type=script&lang=js"
export * from "./HighFrequency.vue?vue&type=script&lang=js"
import style0 from "./HighFrequency.vue?vue&type=style&index=0&id=1366a4e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1366a4e9",
  null
  
)

export default component.exports